import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { AuthService } from '../api/auth.service';
import { UserService } from '../services/user.service';
import { User } from '../models/user';

export const currentUserResolver: ResolveFn<User | null> = (): Observable<User | null> => {
  const authService = inject(AuthService);
  const userService = inject(UserService);

  // Use cached user if already loaded
  const currentUser = userService.getCurrentUser();
  if (currentUser) {
    return of(currentUser);
  }

  return authService.getUserDetails().pipe(
    tap((user) => userService.setCurrentUser(user)),
    catchError((error) => {
      console.error('Failed to load current user:', error);
      return of(null);
    })
  );
};
